module.exports = __webpack_public_path__ + "static/media/uk-flag.596bc5ce.svg";